export default __webpack_public_path__ + "static/imda2017top6-b1307ed5808c0c26634e7a106204440c.jpg";